import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const respiratoryCondition: AnswerPathTreeNode = {
  path: 'condition',
  children: [{ path: 'hasCondition', nodeId: NodeIds.healthInsuredRespiratoryHasCondition }],
};
